import CarriersTable from "./CarriersTable";
export default CarriersTable;
